<template>
    <div class="transaction_h">
        <div class="tab_box">
            <div :class="form.state==1?'active':''" @click="change_state(1)">{{$t("new1_txt.Settled")}}</div>
            <div :class="form.state==2?'active':''" @click="change_state(2)">{{$t("new1_txt.Unsettled")}}</div>
        </div>

        <div class="t_h1">
            <div class="t_h1_top">{{ $t("main.text322") }}</div>
            <div class="t_h1_box">
                <el-form class="zdy_form" label-position="top" :model="form">
                    <el-form-item :label="$t('main.text99')" class="riqi_box">
                        <el-date-picker popper-class="time_box month_box" :clearable="false" :editable="false" v-model="form.time" type="month" :format="v_lan == 'en' ? 'MM/yyyy' : 'yyyy/MM'" value-format="yyyy-MM" range-separator="-" :placeholder="month_pld" @change="month_change" :picker-options="pickerOptions_4">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="btn_box">
                        <el-button class="reset_btn border_set_color" size="medium" @click="reset_btn">{{ $t("main.text329") }}</el-button>
                        <el-button class="apply_btn" size="medium" @click="apply_btn">{{
                            $t("main.text330")
                            }}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="t_h2">
            <div class="t_h2_box">
                <div>
                    <div class="t_h2_txt1">{{ $t("main.text270") }}</div>
                    <!-- <div class="t_h2_txt2"></div> -->
                </div>
                <div>
                    <el-button class="export_btn border_set_color2" icon="el-icon-download" size="medium" @click="download_btn">{{ $t("main.text333") }}</el-button>
                </div>
            </div>
            <div class="t_h2_table zdy_tab_header">
                <!-- <el-table :data="tableData" stripe style="width: 100%"> -->
                <el-table :data="tableData.slice((page - 1) * limit, page * limit) " stripe style="width: 100%">
                    <el-table-column :label="$t('main.text99')">
                        <span slot-scope="props">
                            <!-- {{ overall_time(props.row.c_time) }} -->
                            {{set_time( props.row.date )}}
                        </span>
                    </el-table-column>
                    <el-table-column :label="$t('bank_card.Username')">
                        <span slot-scope="props">
                            {{ props.row.username }}
                        </span>
                    </el-table-column>
                    <el-table-column :label="$t('bank_card.card_number')">
                        <span slot-scope="props">
                            {{ props.row.card_number }}
                        </span>
                    </el-table-column>
                    <el-table-column :label="$t('main.text710')">
                        <span slot-scope="props">
                            {{ props.row.description||"-"}}
                        </span>
                    </el-table-column>
                    <el-table-column :label="$t('bank_card.describe')">
                        <span slot-scope="props">
                            {{ props.row.detail||"-"}}
                        </span>
                    </el-table-column>
                    <el-table-column :label="$t('main.text682')">
                        <span slot-scope="props">
                            {{ props.row.currency }}
                        </span>
                    </el-table-column>
                    <el-table-column :label="$t('main.text314')">
                        <span slot-scope="props">
                            {{ props.row.base_amount }}
                        </span>
                    </el-table-column>
                    <!-- <el-table-column :label="$t('main.text711')">
                        <span slot-scope="props">
                            {{ props.row.transaction_total }}
                        </span>
                    </el-table-column> -->
                    <el-table-column :label="$t('main.text712')">
                        <span slot-scope="props">
                            {{ props.row.transaction_id }}
                        </span>
                    </el-table-column>
                </el-table>
                <el-pagination v-if="tableData.length > 0" background :page-sizes="[10, 20, 30, 40]" :page-size="limit" :current-page.sync="currentPage" layout="prev, pager, next" :total="page_total" @current-change="current_change"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { transactionDetails, transactionDownload } from "@/api/api";
export default {
    data() {
        return {
            form: {
                time: "",
                state:1,
            },
            time_list: [],
            id: '',
            currentPage: 1,
            page: 1, //分页 从 1 开始
            limit: 10, //每页条数
            page_total: 0, //一共多少条
            tableData: [],
            // 日期只可以是当前往前4个月
            // 卡交易记录，之前限制的是4个月，现在换成6个月
            // 20240605 上一年全部可见 到当前月份
            pickerOptions_4: {
                disabledDate(time) {
                    let now = new Date(); //当前日期
                    let nowMonth = now.getMonth() + 1; //当前月份
                    let nowYear = now.getFullYear(); //当前年
                    // 开始月份
                    let startMonth = new Date(nowYear - 1, 0, 1);
                    // 结束月份
                    let endMonth = new Date(nowYear, nowMonth, 0);
                    return time.getTime() < startMonth || time.getTime() > endMonth;
                }
            },
            month_pld: ''
        };
    },
    beforeDestroy() {
        sessionStorage.removeItem("top_title_name");
    },
    beforeMount() {
        this.id = this.$route.query.id;
    },
    mounted() {
        sessionStorage.setItem("top_title_name", this.$t("main.text270"));
        this.get_list();
        this.set_month();
    },
    methods: {
        get_list() {
            let date = new Date();
            transactionDetails({
                card_id: this.id,
                year: this.time_list.length ? this.time_list[0] * 1 : date.getFullYear(),
                month: this.time_list.length ? this.time_list[1] * 1 : date.getMonth() + 1,
                state: this.form.state,
            }).then((res) => {
                if (res.data.code == 200) {
                    // console.log(res.data.data);
                    this.page_total = res.data.data.length;
                    this.tableData = res.data.data;
                } else {
                    this.message.ismessage('error', res.data.msg);
                }
            });
        },
        change_state(v){
            this.form.state = v;
            this.get_list();
        },
        reset_btn() {
            this.time_list = [];
            this.form.time = "";
            this.page = 1;
            this.limit = 10;
            this.currentPage = 1;
            this.get_list();
            this.set_month();
        },
        apply_btn() {
            // console.log(this.form);
            this.page = 1;
            this.limit = 10;
            this.currentPage = 1;
            this.get_list();
        },
        current_change(v) {
            // console.log(v);
            this.page = v;
            this.limit = 10;
            // this.get_list();
        },
        download_btn() {
            if (this.page_total <= 0) {
                return this.message.ismessage('error', this.$t('main.text335'));
            }
            let date = new Date();
            transactionDownload({
                card_id: this.id,
                year: this.time_list.length ? this.time_list[0] * 1 : date.getFullYear(),
                month: this.time_list.length ? this.time_list[1] * 1 : date.getMonth() + 1,
                state: this.form.state,
            }).then(res => {
                const filename = res.headers['content-disposition'].split(';')[1].split('=')[1] || 'download.xlsx';
                const link = document.createElement('a')
                const blob = new Blob([res.data], { type: 'application/octet-stream' })
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                // link.setAttribute('download', `download.xlsx`)
                link.setAttribute('download', `${filename}`)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
        },
        set_time(v) {
            // v;
            // 07/10/2022----2022/10/07
            if (this.v_lan == 'ch') {
                let str = v.split("/");
                return str[2] + "/" + str[1] + "/" + str[0];
            } else {
                return v;
            }

        },
        month_change(v) {
            this.time_list = v.split('-');
            // console.log(v);
            // console.log(this.time_list);
        },
        set_month() {
            let now = new Date(); //当前日期
            let nowMonth = now.getMonth() + 1; //当前月份
            let nowYear = now.getFullYear(); //当前年
            let time = '';
            if (this.v_lan == 'ch') {
                time = `${nowYear}/${nowMonth<10?'0'+nowMonth:nowMonth}`;
            } else {
                time = `${nowMonth<10?'0'+nowMonth:nowMonth}/${nowYear}`;
            }
            if (time) {
                this.month_pld = time;
            }
        }

    },
};
</script>
<style scoped>
.t_h1_top {
    margin-top: 40px;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 16px;
}

.t_h1_box {
    background: #314b69;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 28px;
    padding-bottom: 6px;
}

.zdy_form>>>.el-form-item {
    display: inline-block;
    width: 252px;
    margin-right: 20px;
}

.zdy_form>>>.el-date-editor.el-input,
.zdy_form>>>.el-select {
    width: 100%;
}

.zdy_form>>>.el-form-item:last-child {
    margin-right: 0;
}

.zdy_form>>>.el-form-item__label {
    padding: 0;
    line-height: inherit;
    margin-bottom: 8px;
    color: rgba(255, 255, 255, 0.6);
}

.zdy_form>>>.el-input__inner {
    background: #223c58;
    border: none;
    border-radius: 8px;
    color: #fff;
}

.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
    color: #deb981;
    border-color: #deb981;
    background: transparent;
    min-width: 120px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    border-radius: 4px;
}

.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
    min-width: 120px;
    border-color: #f1c788;
    background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #04182a;
}

.zdy_form .btn_box {
    width: auto;
}

.t_h2_box {
    display: flex;
    justify-content: space-between;
    margin-top: 80px;
    align-items: center;
}

.t_h2_txt1 {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 4px;
}

.t_h2_txt2 {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.8);
}

.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
    color: #deb981;
    border-color: #deb981;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    min-width: 120px;
    background: transparent;
}

.icon_width {
    width: 20px;
    vertical-align: middle;
    cursor: pointer;
}

.color_red {
    color: #f35f65;
}
.tab_box{
    display: flex;
    border-bottom: 1px solid #314B69;
}
.tab_box>div{
    margin-right: 20px;
    cursor: pointer;
}
.active{
  font-style: normal;
  font-weight: 700;
  color: #deb981;
  border-bottom: 3px solid #deb981;
  padding-bottom: 4px;
}
</style>
<style>
.month_box .el-month-table td .cell {
    color: #fff;
}

.month_box .el-month-table td.disabled .cell {
    color: #C0C4CC;
}

@media screen and (max-width: 850px) {
    .month_box {
        left: 6% !important;
        width: 87% !important;
    }
}
</style>
<style scoped>
@media screen and (max-width: 850px) {
    .t_h1_top {
        margin-top: 0;
    }

    .t_h2_box {
        margin-top: 40px;
        align-items: flex-start;
    }
}
</style>